module.exports = __webpack_public_path__ + "static/media/certificate-background.abe76f74.png";